import "./maintenancePage.css";

const MaintenancePage = () => {

  return (
    <div className="maintenance-container">
      <h1 className="maintenance">⚙️ Estamos en Mantenimiento</h1>
      <p >Volveremos pronto. Gracias por tu paciencia. ⏳</p>
      <div className="loader"></div>
    </div>
  );
};

export default MaintenancePage;
